import type { ReactNode } from 'react'
import { useI18n } from '../i18n'

export function PageHeader({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  const { t } = useI18n()
  return <header className="mb-6 flex flex-col gap-4 sm:mb-7 sm:flex-row sm:flex-wrap sm:items-end sm:justify-between">
    <div><h1 className="text-xl font-bold tracking-tight sm:text-2xl">{t(title)}</h1>{description && <p className="mt-1 text-sm text-muted-foreground">{t(description)}</p>}</div>
    {action}
  </header>
}
